var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-slash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.359 11.238C15.06 9.72 16 8 16 8C16 8 13 2.5 8 2.5C7.03959 2.5033 6.09005 2.70342 5.21 3.088L5.98 3.859C6.62744 3.62315 7.31095 3.50167 8 3.5C10.12 3.5 11.879 4.668 13.168 5.957C13.7884 6.58069 14.3445 7.26512 14.828 8C14.77 8.087 14.706 8.183 14.633 8.288C14.298 8.768 13.803 9.408 13.168 10.043C13.003 10.208 12.831 10.371 12.651 10.529L13.359 11.238Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.297 9.176C11.5202 8.55184 11.5615 7.87714 11.4162 7.23042C11.2709 6.58369 10.9449 5.99152 10.4762 5.52282C10.0075 5.05411 9.41531 4.72814 8.76858 4.58283C8.12185 4.43752 7.44716 4.47884 6.823 4.702L7.646 5.525C8.03031 5.46999 8.42215 5.50524 8.79047 5.62796C9.15879 5.75068 9.49347 5.95749 9.76799 6.23201C10.0425 6.50653 10.2493 6.8412 10.372 7.20953C10.4948 7.57785 10.53 7.96969 10.475 8.354L11.297 9.176ZM8.354 10.475L9.176 11.297C8.55184 11.5202 7.87715 11.5615 7.23042 11.4162C6.58369 11.2709 5.99153 10.9449 5.52282 10.4762C5.05411 10.0075 4.72814 9.4153 4.58283 8.76858C4.43752 8.12185 4.47885 7.44715 4.702 6.823L5.525 7.646C5.46999 8.03031 5.50524 8.42215 5.62796 8.79047C5.75068 9.15879 5.95749 9.49347 6.23201 9.76799C6.50653 10.0425 6.84121 10.2493 7.20953 10.372C7.57785 10.4948 7.96969 10.53 8.354 10.475Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35 5.47C3.17 5.63 2.997 5.792 2.832 5.957C2.21165 6.58069 1.65552 7.26512 1.172 8L1.367 8.288C1.702 8.768 2.197 9.408 2.832 10.043C4.121 11.332 5.881 12.5 8 12.5C8.716 12.5 9.39 12.367 10.02 12.14L10.79 12.912C9.90994 13.2965 8.9604 13.4967 8 13.5C3 13.5 0 8 0 8C0 8 0.939 6.279 2.641 4.762L3.349 5.471L3.35 5.47ZM13.646 14.354L1.646 2.354L2.354 1.646L14.354 13.646L13.646 14.354Z",
    fill: "#212529"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.4588b18f6e8a655653a8e67f096f6842.svg";
export { ForwardRef as ReactComponent };